import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import * as DateHelpers from './DateHelpers';

interface InvoicingPaidDateProps {
    date: string;
    canUpdatePaid: boolean;
    showModal: boolean;
    hideModal(): void;
    update(date: string): void;
    save(): void;
}

interface InvoicingPaidDate {
    errors: any;
}

export default class InvoicingPaidDateModal extends React.Component<InvoicingPaidDateProps, InvoicingPaidDate> {
    constructor(props: InvoicingPaidDateProps) {
        super(props);
        this.state = {
            errors: {}
        }
    }

    hideModal = () => {
        this.setState({ errors: {} });
        this.props.hideModal();
    }

    handleDateChange = (e: any) => {
        this.props.update(e.target.value);
        this.setState({ errors: {} });
    }

    validate = () => {
        let errors: any = {};
        let formIsValid = true;

        if (!this.props.date) {
            errors["date"] = "Enter a Valid Date";
            formIsValid = false;
        } else if (!DateHelpers.isValidDate(this.props.date)) {
            errors["date"] = "Enter a Valid Date";
            formIsValid = false;
        } else if (DateHelpers.isDateInFuture(this.props.date)) {
            //can't be > today
            errors["date"] = "Date must be today or earlier";
            formIsValid = false;
        }

        this.setState({ errors: errors });
        return formIsValid;
    }


    save = (e: any) => {
        e.preventDefault();

        if (this.validate()) {
            this.props.save();
        }
    }

    render() {
        return (
            <div>
                <Modal size="sm" show={this.props.showModal} onHide={this.hideModal}>
                    <Modal.Header className="modal__header--colour">
                        <Modal.Title>Enter Paid Date</Modal.Title>
                        <button type="button" className="close" onClick={this.hideModal}>&times;</button>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <label className="input-group" htmlFor="date">
                                <span className="label">Paid Date</span>
                                <input type='date' id="date" name="date" className='input' value={this.props.date} onChange={(e) => this.handleDateChange(e)}></input>
                            </label>
                            <span className="label errors">{this.state.errors["date"]}</span>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <button className={this.props.canUpdatePaid ? "popup-button--yes" : "hidden"} onClick={this.save}>Save</button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}